import { useEffect, useState } from "react";
import axios from "axios";
import { Pencil, Trash2 } from "lucide-react";
import "../../styles/settings/ProhibitedWords.css";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/prohibited-words`;

const ProhibitedWords = () => {
  const [words, setWords] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingWord, setEditingWord] = useState(null);
  const [inputWord, setInputWord] = useState("");

  const token = localStorage.getItem("token");

  /* ================= LOAD ================= */
  const loadWords = async () => {
    try {
      const res = await axios.get(API_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setWords(res.data);
    } catch (err) {
      console.error("Load words failed", err);
    }
  };

  useEffect(() => {
    loadWords();
  }, []);

  /* ================= OPEN ADD ================= */
  const openAdd = () => {
    setEditingWord(null);
    setInputWord("");
    setShowModal(true);
  };

  /* ================= OPEN EDIT ================= */
  const openEdit = (item) => {
    setEditingWord(item);
    setInputWord(item.prohibited_word);
    setShowModal(true);
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!inputWord.trim()) return;

    try {
      if (editingWord) {
        await axios.put(
          `${API_URL}/${editingWord.pw_id}`,
          { prohibited_word: inputWord },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        await axios.post(
          API_URL,
          { prohibited_word: inputWord },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      setShowModal(false);
      loadWords();
    } catch (err) {
      alert("Operation failed");
    }
  };

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this word?")) return;

    try {
      await axios.delete(`${API_URL}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      loadWords();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <div className="settings-page">
      {/* ✅ COMMON HEADER */}
      <div className="settings-header">
        <h2>Prohibited Words Management</h2>
        <button className="add-btn" onClick={openAdd}>
          + Add New Word
        </button>
      </div>

      {/* ✅ COMMON TABLE */}
      <table className="settings-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Prohibited Word</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {words.map((w) => (
            <tr key={w.pw_id}>
              <td>{w.pw_id}</td>
              <td>{w.prohibited_word}</td>

              <td>
                <button
                  className="action-btn"
                  onClick={() => openEdit(w)}
                  title="Edit"
                >
                  <Pencil size={16} />
                </button>

                <button
                  className="action-btn delete"
                  onClick={() => handleDelete(w.pw_id)}
                  title="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Prohibited Word</h3>

            <label>Word</label>
            <input
              value={inputWord}
              onChange={(e) => setInputWord(e.target.value)}
              placeholder="Enter word"
            />

            <div className="modal-actions">
              <button
                className="secondary-btn"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
              <button className="primary-btn" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProhibitedWords;
